import { doc, updateDoc } from 'firebase/firestore';

function InteractionFactory(firebase) {
  const forceActiveTab = async ({ eventId, tabName }) =>
    updateDoc(doc(firebase.fsdb, 'events', eventId), {
      forcedActiveTab: tabName
    });

  return {
    forceActiveTab
  };
}

export default InteractionFactory;
